import { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Formik } from "formik";
import { Slide, ToastContainer, toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { DefaultLayout } from "../../../../../../layouts/Default";
import { TopNavigation } from "../../../../../../themes/Default/components/TopNavigation";
import { Button, ButtonBack } from "../../../../../../themes/Default/components/TopNavigation/components/Button";
import { Tabs } from "../../../../../../themes/Default/components/Tabs";
import { Main } from "../../../../../../themes/Default/components/Main";
import { Breadcrumps } from "../../../../../../themes/Default/components/Breadcrumps";
import { Link } from "../../../../../../themes/Default/components/Breadcrumps/components/Link";
import { Form } from "../../../../../../themes/Default/components/Form";
import { Row } from "../../../../../../themes/Default/components/Form/components/Row";
import { Field } from "../../../../../../themes/Default/components/Form/components/Row/components/Field";
import { Input } from "../../../../../../themes/Default/components/Form/components/Input";
import { Textarea } from "../../../../../../themes/Default/components/Form/components/Textarea";
import { reportTypesManagement } from "../../../../../../hooks/api/ReportTypesManagement/ReportTypesManagement";
import SummerNote from "../../../../../../packages/SummerNote/SummerNote";

const EditType = () => {
    const { t } = useTranslation("common");
    const formRef = useRef(null);
    const navigate = useNavigate();
    const { reportTypeId } = useParams();
    const [formErrors, setFormErrors] = useState([]);
    const { useUpdateReportTypesMutation, useViewReportTypesMutation} = reportTypesManagement;
    const [updateReportType, {isLoading: isUpdateingReport}] = useUpdateReportTypesMutation();
    const [viewReportType] = useViewReportTypesMutation();
    const [saving, setSaving] = useState(false);

    const tabs = [
        { title: t("reports.typeTitle"), isActive: true },
    ];

    const onSave = () => {
        if (formRef.current) {
            setSaving(true);
            formRef.current.handleSubmit();
        }
    };

    const onSaved = (values) => {
        const body = {...values};
        updateReportType({body, reportTypeId}).then((result) => {
            if (result?.error) {
                setFormErrors(result?.error?.data?.error?.violations);
                toast.error(result.error.data.error.responseMessage);
            } else {
                navigate("/settings/reports/types");
                toast.info(result?.data?.info?.responseMessage);
            }
        });
        setSaving(false);
    };

    useEffect(() => {
        viewReportType(reportTypeId).then((result) => {
            formRef.current.setValues(result?.data);
        });

    }, []);

    return (
        <DefaultLayout>
            
            <TopNavigation>
                <ButtonBack to="/settings/reports/types" />
                <Button title={t('save')} isDisabled={isUpdateingReport} icon="fa-regular fa-floppy-disk" onClick={onSave}></Button>
            </TopNavigation>
            <Tabs tabs={tabs} />
            <Main>
                <Breadcrumps>
                    <Link title={t("reports.title")} icon="fa-gear" />
                    <Link title={t("reports.typeTitle")} />
                    <Link title={t("reports.update")} isActive={true} />
                </Breadcrumps>
                <Formik
                        innerRef={formRef}
                        initialValues={{
                            name: "",
                            description: ""
                        }}
                        onSubmit={onSaved}
                    >
                    {({ values, handleChange}) => (
                        <Form>
                            <Row>
                                <Field>
                                    <Input
                                        name="name"
                                        label={t("reports.name")}
                                        required={true}
                                        value={values.name}
                                        onChange={handleChange}
                                        error={formErrors?.name}
                                        hint="Ovaj naslov ce biti prikazan u izvestaju i imejlu"
                                    />
                                </Field>        
                            </Row>
                            <Row>
                                <Field isFullWidth={true}>
                                    <SummerNote
                                        saving={saving}
                                        height="500px"
                                        name="description"
                                        label={t("reports.description")}
                                        value={values.description}
                                        onChange={handleChange}
                                        error={formErrors?.description}
                                        hint="Ova poruka ce biti prikazana u izvestaju"
                                    />
                                </Field>                              
                            </Row>
                        </Form>
                    )}
                </Formik>
            </Main>
        </DefaultLayout>
    );
};

export default EditType;